import { memoize } from "lodash";
import { observable } from "mobx";
import { apiCallGetUserSelfieVerificationPhotos } from "../../../api/user-api/api-call-get-user-selfie-verification-photos";
import { TDebugAIImageCompareData } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class SelfieVerificationPhotosStore {
  userIDInput = observable.box<number>(0);
  userSelfieVerificationPhotos = observable.box<TDebugAIImageCompareData>([]);

  getUserSelfieVerificationPhotos = async () => {
    getCoreUIStore().setIsLoading("DEVELOPER_DEBUG_IMAGE_AI", true);
    const { status, data, code } = await apiCallGetUserSelfieVerificationPhotos(
      {
        userID: this.userIDInput.get()
      }
    );
    getCoreUIStore().setIsLoading("DEVELOPER_DEBUG_IMAGE_AI", false);
    if (status === "OK") {
      this.userSelfieVerificationPhotos.set(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getSelfieVerificationPhotosStore = memoize(
  () => new SelfieVerificationPhotosStore(),
  () => 1
);
export default getSelfieVerificationPhotosStore;
